export const STATE_CATEGORY_CONFIG = [
  { key: 'veryHighImprovement', fill: '#4A8C66', labelId: 'monitoringStateCatVeryHighImprovement', labelDefaultMessage: 'Very substantial improvement (>160%)' },
  { key: 'substantialImprovement', fill: '#22c55e', labelId: 'monitoringStateCatSubstantialImprovement', labelDefaultMessage: 'Substantial improvement (>130-160%)' },
  { key: 'moderateImprovement', fill: '#70E99C', labelId: 'monitoringStateCatModerateImprovement', labelDefaultMessage: 'Moderate improvement (>110-130%)' },
  { key: 'unchanged', fill: '#a7f3d0', labelId: 'monitoringStateCatUnchanged', labelDefaultMessage: 'Unchanged (>90-110%)' },
  { key: 'moderateDeterioration', fill: '#FBBF24', labelId: 'monitoringStateCatModerateDeterioration', labelDefaultMessage: 'Moderate deterioration (>70-90%)' },
  { key: 'substantialDeterioration', fill: '#f97316', labelId: 'monitoringStateCatSubstantialDeterioration', labelDefaultMessage: 'Substantial deterioration (>40-70%)' },
  { key: 'verySevereDeterioration', fill: '#ef4444', labelId: 'monitoringStateCatVerySevereDeterioration', labelDefaultMessage: 'Very severe deterioration (≤40%)' }
]

export const THREAT_IMPACT_CONFIG = [
  { key: 'low', fill: '#22c55e', labelId: 'monitoringImpactLow', labelDefaultMessage: 'Low' },
  { key: 'medium', fill: '#FBBF24', labelId: 'monitoringImpactMedium', labelDefaultMessage: 'Medium' },
  { key: 'high', fill: '#f97316', labelId: 'monitoringImpactHigh', labelDefaultMessage: 'High' },
  { key: 'veryHigh', fill: '#ef4444', labelId: 'monitoringImpactVeryHigh', labelDefaultMessage: 'Very High' }
]

export const TIMING_CONFIG = [
  { key: 'pastUnlikely', fill: '#22c55e', labelId: 'monitoringTimingPastUnlikely', labelDefaultMessage: 'Past/Unlikely' },
  { key: 'pastSuspended', fill: '#F59E0B', labelId: 'monitoringTimingPastSuspended', labelDefaultMessage: 'Past/Suspended' },
  { key: 'ongoing', fill: '#6B7280', labelId: 'monitoringTimingOngoing', labelDefaultMessage: 'Ongoing' },
  { key: 'future', fill: '#A855F7', labelId: 'monitoringTimingFuture', labelDefaultMessage: 'Future' },
  { key: 'unknown', fill: '#D9D9D9', labelId: 'monitoringTimingUnknown', labelDefaultMessage: 'Unknown' }
]

export const IMPACT_LEGEND = [
  ...THREAT_IMPACT_CONFIG.map(({ key, fill, labelId, labelDefaultMessage }) => ({
    key,
    fill,
    labelId,
    labelDefaultMessage
  })),
  { key: 'notAssessed', fill: '#D1D1D1', labelId: 'monitoringImpactNotAssessed', labelDefaultMessage: 'Not assessed' }
]

export const GAUGE_LEVELS = ['none', 'little', 'some', 'most', 'whole']

export const LEVEL_LABELS = {
  none: { id: 'monitoringGaugeNone', defaultMessage: 'None' },
  little: { id: 'monitoringGaugeLittle', defaultMessage: 'Little' },
  some: { id: 'monitoringGaugeSome', defaultMessage: 'Some' },
  most: { id: 'monitoringGaugeMost', defaultMessage: 'Most' },
  whole: { id: 'monitoringGaugeWhole', defaultMessage: 'Whole' },
}

export const LEVEL_COLORS = {
  none: '#ef4444',
  little: '#f59e0b',
  some: '#f59e0b',
  most: '#22c55e',
  whole: '#16a34a',
}

export const REMAINING_COLOR = '#e5e7eb'

export const TICKS = [
  { key: 'none', angle: 180, labelR: 178, lineFromR: 162, lineToR: 174, anchor: 'end' },
  { key: 'little', angle: 135, labelR: 178, lineFromR: 162, lineToR: 174, anchor: 'end' },
  { key: 'some', angle: 90, labelR: 182, lineFromR: 162, lineToR: 174, anchor: 'middle' },
  { key: 'most', angle: 45, labelR: 178, lineFromR: 162, lineToR: 174, anchor: 'start' },
  { key: 'whole', angle: 0, labelR: 178, lineFromR: 162, lineToR: 174, anchor: 'start' },
]

export const TICKS_DATA = [{ key: 'ticks', value: 1 }]

export const TABS = {
  STATE: 'state',
  PRESSURE: 'pressure',
  RESPONSE: 'response',
  EVALUATION: 'evaluation'
}

export const PROGRESS_TABS = [
  { key: TABS.STATE, labelId: 'monitoringTabState', defaultMessage: 'State progress' },
  { key: TABS.PRESSURE, labelId: 'monitoringTabPressure', defaultMessage: 'Pressure progress' },
  { key: TABS.RESPONSE, labelId: 'monitoringTabResponse', defaultMessage: 'Response progress' }
]
